module.exports = __webpack_public_path__ + "static/media/bigMacShutterStock.695e4ee7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bigMacShutterStock.png
// module id = 2416
// module chunks = 2